'use strict'

import firebase from 'firebase/app'
import 'firebaseui/dist/firebaseui.css'

const initializeApp = () => {
  log('auth initializeApp')
  // because change authDomain to web.app from firebaseapp.com
  if (!firebase.apps.length) {
    const firebaseConfig = {
      apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
      appId: process.env.VUE_APP_FIREBASE_API_ID,
      authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
      databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
      measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID,
      messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
      projectId: process.env.VUE_APP_FIREBASE_PROJECT_IDD,
      storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET
    }
    firebase.initializeApp(firebaseConfig)
  }
}

let languageCode = 'en'
let ui
const uiConfig = (cbs) => {
  const { loginSuccess, loginFail, loginNewUser } = cbs
  return {
    signInOptions: [
      firebase.auth.EmailAuthProvider.PROVIDER_ID,
      firebase.auth.GoogleAuthProvider.PROVIDER_ID
    ],
    callbacks: {
      signInSuccessWithAuthResult: function (authResult, redirectUrl) {
        log('signInSuccessWithAuthResult')
        let user = authResult.user
        if (authResult.additionalUserInfo.providerId === 'password') {
          if (authResult.additionalUserInfo.isNewUser) {
            firebase.auth().languageCode = languageCode
            user.sendEmailVerification()
            firebase.auth().signOut()
            if (loginFail)
              loginFail(
                'Check your Email Verification, Verification Email takes few minutes.',
                true
              )
          } else if (user.emailVerified) {
            if (loginSuccess) loginSuccess(authResult, redirectUrl)
          } else {
            if (loginFail)
              loginFail('Login needs Email Verification!', true, user)
          }
        } else {
          if (loginSuccess) loginSuccess(authResult, redirectUrl)
        }
        if (authResult.additionalUserInfo.isNewUser) {
          const { uid, email } = authResult.user
          if (loginNewUser) loginNewUser(uid, email)
        }
      },
      signInFailure: function (error) {
        log.error('signInFailure')
        if (loginFail) loginFail(error)
      }
    }
  }
}

const initAuth = (language, callbacks) => {
  log('auth initAuth')
  if (language === 'ko') {
    import('./esm__ko').then((firebaseui) => {
      reloadUiAuth(firebaseui, callbacks)
    })
  } else {
    import('./esm__en').then((firebaseui) => {
      reloadUiAuth(firebaseui, callbacks)
    })
  }
  languageCode = language
}

const reloadUiAuth = (firebaseui, callbacks) => {
  if (ui) {
    ui.delete().then(() => {
      startUiAuth(firebaseui, callbacks)
    })
  } else {
    startUiAuth(firebaseui, callbacks)
  }
}

const startUiAuth = (firebaseui, callbacks) => {
  ui =
    firebaseui.auth.AuthUI.getInstance() ||
    new firebaseui.auth.AuthUI(firebase.auth())
  if (ui.isPendingRedirect()) {
    ui.start('#firebaseui-auth-container', uiConfig(callbacks))
  }
}

const removeAuth = () => {
  log('auth removeAuth')
  ui.delete()
}

const login = (callbacks) => {
  log('auth login')
  ui.start('#firebaseui-auth-container', uiConfig(callbacks))
}

const logout = (logoutSuccess, logoutFail) => {
  log('auth logout')
  firebase
    .auth()
    .signOut()
    .then(() => {
      if (logoutSuccess) logoutSuccess()
    })
    .catch((error) => {
      if (logoutFail) logoutFail(error)
    })
}

const checkLogin = async () => {
  let user = firebase.auth().currentUser
  if (!user || !user.emailVerified) {
    const email = process.env.VUE_APP_FIREBASE_GUEST_EMAIL
    const password = process.env.VUE_APP_FIREBASE_GUEST_PASSWORD
    return firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then(() => {
        // // Signed in
        // let user = userCredential.user
        return Promise.resolve(true)
      })
      .catch((error) => {
        // let errorCode = error.code
        let errorMessage = error.message
        return Promise.reject(errorMessage)
      })
  } else {
    return Promise.resolve(false)
  }
}

const getUser = () => {
  if (_.isFunction(firebase.auth)) return firebase.auth().currentUser
}

const updatePassword = (newPassword, callback, errorCallback) => {
  let user = firebase.auth().currentUser
  user
    .updatePassword(newPassword)
    .then(() => {
      if (callback) callback()
    })
    .catch((error) => {
      let errorMessage = error.message
      if (errorCallback) errorCallback(errorMessage)
    })
}

const deleteUser = (callback, errorCallback) => {
  let user = firebase.auth().currentUser
  user
    .delete()
    .then(() => {
      if (callback) callback()
    })
    .catch((error) => {
      let errorMessage = error.message
      if (errorCallback) errorCallback(errorMessage)
    })
}

const resendVerification = () => {
  let user = firebase.auth().currentUser
  user.sendEmailVerification()
}

export default {
  initializeApp,
  initAuth,
  removeAuth,
  login,
  logout,
  checkLogin,
  getUser,
  updatePassword,
  deleteUser,
  resendVerification
}
